<template>
  <div>
    <!-- <generic-table
      ref="datatable"
      :title="$t('connection profiles')"
      :columns="columns"
      :column_search="true"
      resource_url="/shortlink/profile/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table> -->

    <!-- Modal para crear/editar perfiles -->
    <profile-datatable ref="profile_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
// import GenericTable from "@/components/generic_table/GenericTable.vue";
import ProfileDatatable from "./profiles_datatable/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  error_message,
  del,
} from "@/utils";

export default {
  name: "Profiles",
  components: { /* GenericTable */ ProfileDatatable },
  data() {
    return {};
  },
  methods: {
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
};
</script>
